module.exports = __webpack_public_path__ + "img/symbol_5.d5d49dc8.png";